<template>
  <v-card
    flat
    :width="width"
    class="d-flex flex-column"
  >
    <v-card
      class="d-flex justify-space-between"
      flat
    >
      <v-card flat class="align-self-center flex-grow-1" :to="get_to()">
        <template v-if="code === 200 && is_linkable()">
          <v-icon>
            mdi-link-variant
          </v-icon>
        </template>
        <template v-if="type === 'organization'">
          <template v-if="code === 200 && is_linkable()">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ $store.getters.user.organization }}&nbsp;({{ ids[ids.length - 1] }}){{ additional }}
                </span>
              </template>
              <span>
                {{ $t("message.common.organization") }}{{ $t("message.common.any_detail") }}
              </span>
            </v-tooltip>
          </template>
          <template v-else>
            {{ $store.getters.user.organization }}&nbsp;({{ ids[ids.length - 1] }}){{ additional }}
          </template>
        </template>
        <template v-else-if="type === 'group' && ['user', 'group'].indexOf(mode) >= 0 && $store.getters.user.gid === ids[ids.length - 1]">
          <template v-if="code === 200 && is_linkable()">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ $store.getters.user.group }}&nbsp;({{ ids[ids.length - 1] }}){{ additional }}
                </span>
              </template>
              <span>
                {{ $t("message.common.group") }}{{ $t("message.common.any_detail") }}
              </span>
            </v-tooltip>
          </template>
          <template v-else>
            {{ $store.getters.user.group }}&nbsp;({{ ids[ids.length - 1] }}){{ additional }}
          </template>
        </template>
        <template v-else-if="type === 'user' && mode === 'user' && $store.getters.user.uid === ids[ids.length - 1]">
          <template v-if="code === 200 && is_linkable()">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ $store.getters.user.name }}&nbsp;({{ ids[ids.length - 1] }}){{ additional }}
                </span>
              </template>
              <span>
                {{ $t("message.common.user") }}{{ $t("message.common.any_detail") }}
              </span>
            </v-tooltip>
          </template>
          <template v-else>
            {{ $store.getters.user.name }}&nbsp;({{ ids[ids.length - 1] }}){{ additional }}
          </template>
        </template>
        <template v-else-if="name">
          <template v-if="code === 200 && is_linkable()">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ name.replace(/\([A-Z]\d{5,8}\)/g, "") }}&nbsp;({{ ids[ids.length - 1] }}){{ additional }}
                </span>
              </template>
              <span>
                {{ $t("message.common." + type) }}{{ $t("message.common.any_detail") }}
              </span>
            </v-tooltip>
          </template>
          <template v-else>
            {{ name.replace(/\([A-Z]\d{5,8}\)/g, "") }}&nbsp;({{ ids[ids.length - 1] }}){{ additional }}
          </template>
        </template>
        <template v-else-if="code === 403">
          <span class="grey--text">{{ ids[ids.length - 1] }}&nbsp;({{ $t("message.common.forbidden") }}){{ additional }}</span>
        </template>
        <template v-else-if="code === 404">
          <span class="grey--text">{{ ids[ids.length - 1] }}&nbsp;({{ $t("message.common.not_found") }}){{ additional }}</span>
        </template>
        <template v-else-if="ids[ids.length - 1] === 'copied'">
          <span class="grey--text">({{ $t("message.common.forbidden") }})</span>
        </template>
        <template v-else>
          {{ ids[ids.length - 1] }}{{ additional }}
        </template>
      </v-card>
      <v-card class="align-self-center" flat>
        <template v-if="type === 'file' && extensions.length > 0 && ids[ids.length - 1] !== 'copied'">
          <v-menu>
            <template v-slot:activator="{ on: onMenu }">
              <v-tooltip top>
                <template v-slot:activator="{ on: onTooltip }">
                  <v-icon
                    v-on="{ ...onMenu, ...onTooltip }"
                    @click.prevent
                    class="ma-1"
                  >
                    mdi-download
                  </v-icon>
                </template>
                <span>{{ $t("message.file.download") }}</span>
              </v-tooltip>
            </template>

            <v-list v-for="extension in extensions" :key="extension">
              <v-list-item dense @click="get_download(ids[ids.length - 1], extension)">
                <v-list-item-content>
                  {{ $t('message.file.download_as', { "extension": $t('message.common.extension_' + extension) } ) }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-if="type === 'file' && previews.length > 0 && ids[ids.length - 1] !== 'copied'">
          <v-menu>
            <template v-slot:activator="{ on: onMenu }">
              <v-tooltip top>
                <template v-slot:activator="{ on: onTooltip }">
                  <v-icon
                    v-on="{ ...onMenu, ...onTooltip }"
                    @click.prevent
                    class="ma-1"
                  >
                    mdi-file-find
                  </v-icon>
                </template>
                <span>{{ $t("message.viewer.preview") }}</span>
              </v-tooltip>
            </template>

            <v-list v-for="extension in previews" :key="extension">
              <v-list-item dense @click="$refs.viewer && $refs.viewer.open(ids[ids.length - 1], extension)">
                <v-list-item-content>
                  {{ $t('message.viewer.preview_as', { "extension": $t('message.common.extension_' + extension) } ) }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-if="
          ['model', 'corpus', 'term'].indexOf(type) >= 0
          && code === 200
          && ids[ids.length - 1] !== 'copied'"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-1" @click.stop.prevent="$refs.parallel_viewer && $refs.parallel_viewer.open(name, type, ids[ids.length - 1])">
                mdi-file-find
              </v-icon>
            </template>
            <span>{{ $t("message.viewer.preview") }}</span>
          </v-tooltip>
        </template>
        <template v-if="
          mode === 'user'
          && type === 'file'
          && ids[ids.length - 1] !== 'copied'
          && code === 200
          && [/*'source',*/'translated'].indexOf(xtype) >= 0
          && previews.indexOf('json') >= 0
          && ($store.getters.user && ['the-reading'].indexOf($store.getters.user.domain) < 0)
        ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-1" @click.stop.prevent="$router.push('/editor/' + xtype + '/' + ids[ids.length - 1] + '?referer=' + nav_path)">
                mdi-book-open
              </v-icon>
            </template>
            <span>{{ $t("message.file.edit_" + xtype) }}</span>
          </v-tooltip>
        </template>
        <!--
        <template v-else-if="mode === 'user'
          && type === 'corpus'
          && ids[ids.length - 1] !== 'copied'
          && code === 200">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-1" @click.stop.prevent="$router.push('/editor/corpus/' + ids[ids.length - 1] + '?referer=' + nav_path)">
                mdi-book-open
              </v-icon>
            </template>
            <span>{{ $t("message.corpus.edit_corpus") }}</span>
          </v-tooltip>
        </template>
        -->
        <template v-if="
          code === 200
          && mode === 'user'
          && type === 'corpus'
          && source
        ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="$router.push('/train'
                + '?corpus=' + ids[ids.length - 1]
                + '&source=' + source
              )">
                mdi-brain
              </v-icon>
            </template>
            <span>{{ $t("message.corpus.train_this") }}</span>
          </v-tooltip>
        </template>
        <template v-if="
          code === 200
          && mode === 'user'
          && type === 'model'
          && source
        ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="$router.push('/translate'
                + '?command_type=translate'
                + '&source=' + source
                + '&model_type=model'
                + '&model=' + ids[ids.length - 1]
                + '&source_lang=' + model_lang_pair[0]
                + '&target_lang=' + model_lang_pair[1]
              )">
                mdi-translate
              </v-icon>
            </template>
            <span>{{ $t("message.model.translate_with_this") }}</span>
          </v-tooltip>
        </template>
      </v-card>
    </v-card>
    <template v-if="type === 'file' && file_remarks">
      <v-card
        flat
      >
        <FileRemark
          :fid="ids[ids.length - 1]"
          :remarks="file_remarks"
          :mode="mode"
          :nav_path="nav_path"
          :visible="remarks"
        />
      </v-card>
    </template>
    <Viewer
      ref="viewer"
      :mode="mode"
    >
    </Viewer>
    <ParallelViewer
      ref="parallel_viewer"
      :mode="mode"
    ></ParallelViewer>
  </v-card>
</template>

<script>
import Viewer from '../components/Viewer';
import ParallelViewer from '../components/ParallelViewer';
import FileRemark from '../components/FileRemark';
import { get_download } from "../js/get_download";
import { http_error } from "../js/http_error";

export default {
  name: 'id_name',
  props: {
    width: {
      type: String,
      required: false,
      default: "100%"
    },
    mode: String,
    type: String,
    ids: Array,
    additional: String,
    remarks: {
      type: Array,
      required: false,
      default: null
    },
    source: String,
    nav_path: String
  },
  components: {
    Viewer,
    ParallelViewer,
    FileRemark
  },
  mixins: [
    get_download,
    http_error
  ],
  data: function(){
    return {
      module_id: "64",
      name: null,
      xtype: null,
      extensions: [],
      previews: [],
      file_remarks: null,
      model_lang_pair: null,
      code: 200
    }
  },
  mounted: function(){
    if(this.is_gettable()){
      this.get_name();
    }
  },
  methods: {
    get_name: function(){
      this.$http.get(this.$store.getters.api_endpoint + "/" + this.get_prefix() + this.type + "/" + this.ids.join("/"))
        .then( response => {
          if(response && "data" in response){
            if(this.$store.getters.debug){
              console.log("response.data:" + JSON.stringify(response.data));
            }
            if(this.type === "job"){
              this.name = response.data.title;
            }else{
              this.name = response.data.name;
            }
            if(this.type === "file"){
              this.extensions = [];
              for(var extension of response.data.extensions){
                if(["cnt", "sim", "json"].indexOf(extension) === -1){
                  this.extensions.push(extension);
                }
              }
              this.previews = [];
              for(var extension of response.data.extensions){
                if(['txt', 'docx', 'xlsx', 'pptx', 'pdf', 'ocr', 'json'].indexOf(extension) >= 0){
                  this.previews.push(extension);
                }
              }
            }
            if(["file"].indexOf(this.type) >= 0
              && "type" in response.data){
              this.xtype = response.data.type;
            }
            if(this.type === 'file'
              && this.remarks
              && response.data.remarks !== null){
              this.file_remarks = response.data.remarks;
            }
            if(this.type === 'model'
              && this.source){
              this.model_lang_pair = [response.data.source_lang, response.data.target_lang];
            }
          }
        })
        .catch( error => {
          if(this.http_error(error)){
            if(error.response.status === 403
              || error.response.status === 404){
              this.code = error.response.status;
            }else{
              this.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
          }
        });
    },
    get_to: function(){
      if(this.code != 200 || !this.is_linkable()){
        return "";
      }
      var xid_to = "/" + this.get_prefix() + this.type;
      if(this.is_gettable()){
        xid_to += "/" + this.ids.join("/");
      }
      if(this.nav_path){
        xid_to += '?referer=' + this.nav_path;
      }
      return xid_to;
    },
    get_prefix: function(){
      if(this.mode === "user"){
        return "";
      }else{
        return this.mode + "/";
      }
    },
    is_gettable: function(){
      // 取得可能か
      return !(this.type === 'organization'
        || (this.type === 'group' && ['user', 'group'].indexOf(this.mode) >= 0)
        || (this.type === 'user' && this.mode === 'user')
        || this.ids[this.ids.length - 1] === "copied");
    },
    is_linkable: function(){
      // リンク可能か
      return !((this.type === 'organization' && ['user', 'group'].indexOf(this.mode) >= 0)
        || (this.type === 'group' && this.mode === 'user')
        || (this.type === 'group' && this.mode === 'group' && this.$store.getters.user.gid !== this.ids[this.ids.length - 1])
        || (this.type === 'user' && this.mode === 'user' && this.$store.getters.user.uid !== this.ids[this.ids.length - 1])
        || this.ids[this.ids.length - 1] === "copied");
    }
  }
}
</script>
